import styled from "@emotion/styled";
import { Box, Paper, Typography } from "@mui/material";

export const PageContainer = styled(Box)`
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 2rem 1.5rem;
`

export const LoadingContainer = styled(Box)`
    width: 100%;
    height: 100%;
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const DadoContainer = styled(Box)`
    margin-top: 1rem;
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed ${props => props.theme.palette.divider};

    &:last-child {
        border-bottom: none;
    }
`


export const DadoCardContainer = styled(Box)`
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed ${props => props.theme.palette.divider};

    &:last-child {
        border-bottom: none;
    }
`

/* ---------------------------------------------------------------------------
 * Layout das páginas de configuração (navegação lateral + painéis de seção)
 * ------------------------------------------------------------------------ */

export const ConteudoContainer = styled(Box)`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    margin-top: 1.5rem;

    @media(max-width: 1080px) {
        flex-direction: column;
        gap: 1rem;
    }
`

export const NavegacaoPaper = styled(Paper)`
    width: 260px;
    flex-shrink: 0;
    padding: 0.5rem;
    position: sticky;
    top: 66px;
    border: 1px solid ${props => props.theme.palette.divider};

    @media(max-width: 1080px) {
        width: 100%;
        position: static;
        top: auto;
    }
`

export const PainelContainer = styled(Box)`
    flex: 1;
    min-width: 0;
    width: 100%;
`

export const LinhaDadoContainer = styled(Box)`
    width: 100%;
    padding: 0.625rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    border-bottom: 1px dashed ${props => props.theme.palette.divider};

    &:last-of-type {
        border-bottom: none;
        padding-bottom: 0;
    }
`

/* ---------------------------------------------------------------------------
 * Cabeçalho de identidade do marketplace
 * ------------------------------------------------------------------------ */

export const CabecalhoPaper = styled(Paper)`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid ${props => props.theme.palette.divider};
`

export const CapaContainer = styled(Box)`
    width: 100%;
    height: 96px;
    background-size: cover;
    background-position: center;
`

export const IdentificacaoContainer = styled(Box)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    padding: 1.25rem 1.5rem;

    @media(max-width: 1080px) {
        flex-direction: column;
        align-items: flex-start;
    }
`

export const AcoesContainer = styled(Box)`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;

    @media(max-width: 1080px) {
        width: 100%;
    }
`

export const ResumoContainer = styled(Box)`
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    border-top: 1px solid ${props => props.theme.palette.divider};
`

export const ResumoItem = styled(Box)`
    flex: 1 1 180px;
    padding: 0.875rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    border-right: 1px solid ${props => props.theme.palette.divider};

    &:last-of-type {
        border-right: none;
    }
`

export const ResumoLabel = styled(Typography)`
    font-size: 0.7rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${props => props.theme.palette.text.secondary};
`
